import React from "react";
import ProductGrid from "../components/ProductGrid";
import "../index.css";
import BannerCarousel from "../components/BannerCarousel";
import AccountExecutiveSection from "../components/AccountExecutiveSection";
import FacebookVideoSection from "../components/FacebookVideoSection";
import SeoManager from "../SeoManager";
import { BUSINESS_EMAIL, BUSINESS_PHONE, DEFAULT_SHARE_IMAGE, SITE_NAME, SITE_URL } from "../seo";

export default function Home() {
  return (
    <div className="app-container">
      <SeoManager
        title="Gold Jewelry Store"
        description="Shop authentic gold jewelry online at Asher Jewels PH. Discover bracelets, necklaces, rings, earrings, and curated collections with secure checkout and nationwide delivery."
        path="/"
        image={DEFAULT_SHARE_IMAGE}
        keywords="gold jewelry Philippines, Asher Jewels PH, gold bracelet, gold necklace, gold ring, gold earrings, online jewelry shop"
        schema={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: SITE_NAME,
            url: SITE_URL,
            logo: DEFAULT_SHARE_IMAGE,
            contactPoint: [
              {
                "@type": "ContactPoint",
                telephone: BUSINESS_PHONE,
                contactType: "customer service",
                email: BUSINESS_EMAIL,
                areaServed: "PH",
                availableLanguage: ["en", "fil"],
              },
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: SITE_NAME,
            url: SITE_URL,
          },
        ]}
      />
      <BannerCarousel />
      <FacebookVideoSection />
      <ProductGrid />
      <AccountExecutiveSection />
    </div>
  );
}
